export default import.meta.ROLLUP_FILE_URL_x5gCo70s7RhCFlbkZe8TaQ